module.exports = __webpack_public_path__ + "static/media/drum5.0052f4b0.ogg";